// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PB_PAYMENT_DETAILS_SET_PASSENGER_DETAILS_RETURN,
} from './constants';

export function setPassengerDetailsReturn(data) {
  return {
    type: PB_PAYMENT_DETAILS_SET_PASSENGER_DETAILS_RETURN,
    data:data
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PB_PAYMENT_DETAILS_SET_PASSENGER_DETAILS_RETURN:
      return {
        ...state,
        passengerDetailsReturn:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/redux/setPassengerDetailsReturn.js